import { render, staticRenderFns } from "./AddAdvertising.vue?vue&type=template&id=13961cc0&scoped=true"
import script from "./AddAdvertising.vue?vue&type=script&lang=js"
export * from "./AddAdvertising.vue?vue&type=script&lang=js"
import style0 from "./AddAdvertising.vue?vue&type=style&index=0&id=13961cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13961cc0",
  null
  
)

export default component.exports